import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/breakerPanel.css';
import { moduleForPath } from '../../lib/breakerPanel';
import useModuleModes from '../../hooks/useModuleModes';

const LABEL = {
    comms: 'Communications', crm: 'CRM', dispatch: 'Dispatch', schedule: 'Schedule', client_app: 'Client App',
    invoices: 'Invoices', payments: 'Payments', events: 'Events',
};

/**
 * Breaker Panel G4: a thin yellow line on every screen of a module that is in Test. It says what Test means in one sentence;
 * admins get a link to the Go-Live Panel. Nothing shows while the mode is unknown or Live.
 */
export function ModuleTestBannerView({ moduleKey, mode, isAdmin = false }) {
    if (!moduleKey || mode !== 'test') return null;
    return (
        <div role="status" className="ia-test-banner" data-testid="module-test-banner">
            <span aria-hidden="true">●</span>
            <span>
                {LABEL[moduleKey] || moduleKey} is in <strong>TEST</strong>: it works fully here, but texts, emails, payments and links only reach the company test list.
                {isAdmin && <> <Link to="/admin/go-live">Go-Live Panel</Link></>}
            </span>
        </div>
    );
}

export default function ModuleTestBanner({ pathname, isAdmin = false }) {
    const modes = useModuleModes();
    const moduleKey = moduleForPath(pathname);
    return <ModuleTestBannerView moduleKey={moduleKey} mode={modes && moduleKey ? modes[moduleKey]?.mode : null} isAdmin={isAdmin} />;
}
